import { fa } from "./cards";

/**
 * متن‌های نمای تماشاچی.
 *
 * تماشاچی «ما» و «حریف» ندارد و هیچ‌کدام از این‌ها هم نباید به او گفته شود:
 * پنجره‌ی پایانِ دست اگر «بردیم» بگوید، تماشاچی یک لحظه فکر می‌کند خودش
 * بازی می‌کرده. پس هر جا که متنِ بازیکن اول‌شخص است، این‌جا نامِ واحد می‌نشیند.
 */

/** نامِ یک واحد (تیم یا نفر) برای تماشاچی: «تیمِ ۱»، «تیمِ ۲». */
export const unitName = (unit: number, teams: boolean) =>
  `${teams ? "تیمِ" : "بازیکنِ"} ${fa(unit + 1)}`;
